import React, { useState, useEffect } from 'react';
import styles from './integrations.module.scss';
import { Col, Row, Image } from 'react-bootstrap';
import { CustomButton } from '../../../shared/customButton';
import CSSLoader from '../../../shared/cssLoader';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { disconnectAccountConnection, establishAccountConnection, getAccountConfigurations, getAccountData } from '../../../../services/util/company';

function Integrations(props) {

    let [isPageLoading, setPageLoading] = useState(false);
    let [isAccountConnected, setAccountConnection] = useState(false);
    let [connectedAccountType, setConnectedAccountType] = useState(null);
    let [isGoogleConnectionLoading, setGoogleConnectionLoading] = useState(false);
    let [isMicrosoftConnectionLoading, setMicrosoftConnectionLoading] = useState(false);
    let [isGoogleDisconnectionLoading, setGoogleDisconnectionLoading] = useState(false);
    let [isMicrosoftDisconnectionLoading, setMicrosoftDisconnectionLoading] = useState(false);
    let [connectedEmail, setConnectedEmail] = useState(false);


    const connectMicrosoftAccount = async () => {
        setMicrosoftConnectionLoading(true);
        let respond = await getAccountConfigurations(1, 2244);
        if (respond.success === true) {
            window.location.replace(respond.data.request_link);
        } else {
            setMicrosoftConnectionLoading(false);
        }
    }

    const connectGoogleAccount = async () => {
        setGoogleConnectionLoading(true);
        let respond = await getAccountConfigurations(2, 4422);
        if (respond.success === true) {
            window.location.replace(respond.data.request_link);
        } else {
            setGoogleConnectionLoading(false);
        }
    }

    const disconnectMicrosoftCalendar = async (connection) => {
        if (props.main_props.permissions.actions.edit_settings === true ) {
            setMicrosoftDisconnectionLoading(true);
            let respond = await disconnectAccountConnection(connection);
            if (respond.success === true) {
                setMicrosoftDisconnectionLoading(false);
                setAccountConnection(false);
                setConnectedAccountType(null);
                setConnectedEmail(null);
            } else {
                setMicrosoftDisconnectionLoading(false);
            }
        }
    }

    const disconnectGoogleCalendar = async (connection) => {
        if (props.main_props.permissions.actions.edit_settings === true ) {
            setGoogleDisconnectionLoading(true);
            let respond = await disconnectAccountConnection(connection);
            if (respond.success === true) {
                setGoogleDisconnectionLoading(false);
                setAccountConnection(false);
                setConnectedAccountType(null);
                setConnectedEmail(null);
            } else {
                setGoogleDisconnectionLoading(false);
            }
        }
    }

    useEffect(() => {
        //getting query parameter value
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let stateID = parseInt(params.get('state'));
        let responseCode = params.get('code');
        if (stateID) {
            if (stateID === 2244) {
                setMicrosoftConnectionLoading(true);
                establishConnection(1, responseCode);
            }
            if (stateID === 4422) {
                setGoogleConnectionLoading(true);
                establishConnection(2, responseCode)
            }
        } else {
            LoadInitialData();
        }

        async function establishConnection(connection, code) {
            let respond = await establishAccountConnection(connection, code);
            if (respond.success === true) {
                window.location.replace('/app/company/settings/integrations');
            } else {
                setMicrosoftConnectionLoading(false);
            }
        }

        async function LoadInitialData() {
            setPageLoading(true);
            let respond = await getAccountData();
            if (respond.success === true) {
                setAccountConnection(respond.data.is_email_account_connected);
                setConnectedAccountType(respond.data.email_account_type ? respond.data.email_account_type : null);
                setConnectedEmail(respond.data.connected_email ? respond.data.connected_email : null);
                setPageLoading(false);
            } else {
                setPageLoading(false);
            }
        }
    }, [])

    return (
        <div>
            {isPageLoading === true ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <div className={styles.mainOuterCard}>
                        <div>
                            <Col>
                                <Row>
                                    <span className={styles.mainCardTopic}>Email Account Integration</span>
                                </Row>
                            </Col>
                            <span className={styles.mainCardDescription}>Connect one of your organization’s Google or Office 365 Email Accounts (ex :- careers@companyxxx.com). After connecting you can automate sending emails.</span>
                            {isAccountConnected && connectedAccountType === 1 ?
                                <div className={styles.accountContainerBox}>
                                    <div>
                                        <Row>
                                            <Col sm={4} md={3} lg={2} xl={1} className="align-self-center">
                                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/office365.png`} fluid />
                                            </Col>
                                            <Col className="align-self-center">
                                                <p className={styles.activeAccountSubTopic}>Microsoft 365 / Outlook Calendar</p>
                                                <p className={styles.connectedEmailAddress}>{connectedEmail}</p>
                                            </Col>
                                            <Col md={4} lg={3} xl={2} className="align-self-center">
                                                <div data-tooltip-id={`disconnectEmailConnection`} className={styles.disconnectButton} onClick={!isMicrosoftDisconnectionLoading ? () => disconnectMicrosoftCalendar(1) : null}>
                                                    <span>
                                                        Disconnect&nbsp; 
                                                    </span>
                                                    {isMicrosoftDisconnectionLoading ?
                                                        <span >
                                                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                        </span>
                                                        :
                                                        <span >
                                                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd"  stroke-width="1" d="M10.8736 21.3168C11.633 21.8521 12.5585 22.1667 13.5563 22.1667L19.3896 22.1667V24.5H21.723L21.723 9.43417L19.3896 11.9897L19.3896 19.8333L13.5563 19.8333C13.1652 19.8333 12.7963 19.7367 12.4722 19.566L10.8736 21.3168ZM9.51732 19.8361L11.2618 17.9255C11.2363 17.7875 11.223 17.6453 11.223 17.5V10.5C11.223 9.21317 12.2695 8.16667 13.5563 8.16667L19.3896 8.16667V9.02355L21.723 6.468V3.5H19.3896V5.83333L13.5563 5.83333C10.9826 5.83333 8.88965 7.92633 8.88965 10.5V12.8333H3.05631L3.05631 15.1667H8.88965V17.5C8.88965 18.3506 9.11827 19.1487 9.51732 19.8361ZM26.3896 10.5V8.16667H22.8896V10.5H26.3896ZM26.3896 19.8333V17.5H22.8896V19.8333H26.3896Z" fill="#EB5757" />
                                                                <line x1="23.9341" y1="5.17596" x2="7.99907" y2="21.9963"  stroke-width="1" />
                                                            </svg>
                                                        </span>
                                                    }
                                                </div>
                                                <ReactTooltip id={`disconnectEmailConnection`} place="left" type="dark" effect="solid">
                                                    <span>{props.main_props.permissions.actions.edit_settings === false ? "You don't have enough permissions to perform this action" : "Disconnect Company Email"}</span>
                                                </ReactTooltip>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                : isAccountConnected && connectedAccountType === 2 ?
                                    <div className={styles.accountContainerBox}>
                                        <div>
                                            <Row>
                                                <Col sm={4} md={3} lg={2} xl={1} className="align-self-center">
                                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/google-logo.png`} fluid />
                                                </Col>
                                                <Col className="align-self-center">
                                                    <p className={styles.activeAccountSubTopic}>Google Account</p>
                                                    <p className={styles.connectedEmailAddress}>{connectedEmail}</p>
                                                </Col>
                                                <Col md={4} lg={3} xl={2} className="align-self-center">
                                                    <div data-tooltip-id={`disconnectEmailConnection`} className={styles.disconnectButton} onClick={!isGoogleDisconnectionLoading ? () => disconnectGoogleCalendar(2) : (props.main_props.permissions.actions.edit_settings === false) ? null : null}>
                                                        <span>
                                                            Disconnect&nbsp;
                                                        </span>
                                                        {isGoogleDisconnectionLoading ?
                                                            <span >
                                                                <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                            </span>
                                                            :
                                                            <span >
                                                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" stroke-width="1" d="M10.8736 21.3168C11.633 21.8521 12.5585 22.1667 13.5563 22.1667L19.3896 22.1667V24.5H21.723L21.723 9.43417L19.3896 11.9897L19.3896 19.8333L13.5563 19.8333C13.1652 19.8333 12.7963 19.7367 12.4722 19.566L10.8736 21.3168ZM9.51732 19.8361L11.2618 17.9255C11.2363 17.7875 11.223 17.6453 11.223 17.5V10.5C11.223 9.21317 12.2695 8.16667 13.5563 8.16667L19.3896 8.16667V9.02355L21.723 6.468V3.5H19.3896V5.83333L13.5563 5.83333C10.9826 5.83333 8.88965 7.92633 8.88965 10.5V12.8333H3.05631L3.05631 15.1667H8.88965V17.5C8.88965 18.3506 9.11827 19.1487 9.51732 19.8361ZM26.3896 10.5V8.16667H22.8896V10.5H26.3896ZM26.3896 19.8333V17.5H22.8896V19.8333H26.3896Z" fill="#EB5757" />
                                                                    <line x1="23.9341" y1="5.17596" x2="7.99907" y2="21.9963"  stroke-width="1" />
                                                                </svg>
                                                            </span>
                                                        }

                                                    </div>
                                                    <ReactTooltip id={`disconnectEmailConnection`} place="left" type="dark" effect="solid">
                                                        <span>{props.main_props.permissions.actions.edit_settings === false ? "You don't have enough permissions to perform this action" : "Disconnect Company Email"}</span>
                                                    </ReactTooltip>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    : !isAccountConnected ?
                                        <div className={styles.accountContainerBox}>
                                            <div>
                                                <Row>
                                                    <Col sm={4} md={3} lg={2} xl={1} className="align-self-center">
                                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/google-logo.png`} fluid />
                                                    </Col>
                                                    <Col className="align-self-center">
                                                        <p className={styles.accountSubTopic}>Connect with Google Account</p>
                                                        <p className={styles.accountDescription}>Connect Google account which you want to send emails </p>
                                                    </Col>
                                                    <Col md={4} lg={3} xl={2} className="align-self-center">
                                                        <CustomButton
                                                            id="google_acc_connect"
                                                            type="primarySmallBtn"
                                                            label="Connect"
                                                            buttonType="button"
                                                            backicon={isGoogleConnectionLoading ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                                            disabled={isGoogleConnectionLoading || isMicrosoftConnectionLoading ? true : false || (props.main_props.permissions.actions.edit_settings === false) ? true : false}
                                                            handleClick={() => connectGoogleAccount()}
                                                            toolTipId={props.main_props.permissions.actions.edit_settings === false  && "permissionError"}
                                                            toolTip={props.main_props.permissions.actions.edit_settings === false  && "You don't have enough permissions to perform this action"}
                                                            showToolTip={props.main_props.permissions.actions.edit_settings === false ? true : false}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                            <hr className={styles.horizontalLine} />
                                            <div>
                                                <Row>
                                                    <Col sm={4} md={3} lg={2} xl={1} className="align-self-center">
                                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/office365.png`} fluid />
                                                    </Col>
                                                    <Col className="align-self-center">
                                                        <p className={styles.accountSubTopic}>Connect with Microsoft 365 / Outlook Account</p>
                                                        <p className={styles.accountDescription}>Connect Outlook account which you want to send emails </p>
                                                    </Col>
                                                    <Col md={4} lg={3} xl={2} className="align-self-center">
                                                        <CustomButton
                                                            id="outlook_acc_connect"
                                                            type="primarySmallBtn"
                                                            label="Connect"
                                                            buttonType="button"
                                                            backicon={isMicrosoftConnectionLoading ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                                            disabled={isMicrosoftConnectionLoading || isGoogleConnectionLoading ? true : false || (props.main_props.permissions.actions.edit_settings === false ) ? true : false}
                                                            handleClick={() => connectMicrosoftAccount()}
                                                            toolTipId={props.main_props.permissions.actions.edit_settings === false  && "permissionError"}
                                                            toolTip={props.main_props.permissions.actions.edit_settings === false  && "You don't have enough permissions to perform this action"}
                                                            showToolTip={props.main_props.permissions.actions.edit_settings === false  ? true : false}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                        : null
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Integrations;
